module.exports = __webpack_public_path__ + "static/img/qx.b331920f.png";